import { useMutation } from '@apollo/client';
import { CREATE_PSA } from '../../services/apollo/mutations/psaMutations';
import { CREATE_LOST_ANIMAL } from '../../services/apollo/mutations/lostAnimalMutations';
import { CREATE_FOUND_ANIMAL } from '../../services/apollo/mutations/foundAnimalMutations';
import { CREATE_PET_SERVICE } from '../../services/apollo/mutations/petServiceMutations';
import { GET_FEED } from '../../services/apollo/queries/feedQueries';

/**
 * Mutation map by category
 */
const CATEGORY_MUTATION_MAP = {
  'psa': CREATE_PSA,
  'lost-animal': CREATE_LOST_ANIMAL,
  'found-animal': CREATE_FOUND_ANIMAL,
  'pet-service': CREATE_PET_SERVICE,
};

const useCreateNotification = (category) => {
  // Get mutation for category, default to PSA
  const mutation = CATEGORY_MUTATION_MAP[category] || CREATE_PSA;

  // Refetch the unified feed query after creating a post
  const [createNotification, { data, loading, error }] = useMutation(mutation, {
    refetchQueries: [GET_FEED],
    awaitRefetchQueries: true,
  });

  const createNewNotification = async (input) => {
    try {
      const result = await createNotification({ variables: { input } });
      return result.data;
    } catch (err) {
      console.error(`Error creating ${category}:`, err);
      throw err;
    }
  };

  return { createNewNotification, data, loading, error };
};

export default useCreateNotification;
